import { useState } from "react"
import { Typography } from "@material-ui/core"
import { colors } from "../../../utils/theme"

/**
 * ClientTooltip is a component that wraps content and shows a hover tooltip
 * containing a client description.
 *
 * @component
 * @param {Object} props - The props object.
 * @param {number} props.desc - The description text/value to display in the tooltip.
 * @param {React.ReactNode} props.children - The element(s) that trigger the tooltip on hover.
 *
 * @returns {JSX.Element} The wrapped children with a tooltip rendered on hover.
 */
export default function ClientTooltip({
  desc,
  children,
}: {
  desc: number
  children: React.ReactNode
}) {
  const [isTooltipVisible, setTooltipVisible] = useState(false)

  const handleMouseEnter = () => {
    setTooltipVisible(true)
  }

  const handleMouseLeave = () => {
    setTooltipVisible(false)
  }

  return (
    <div
      style={{ position: "relative", display: "flex", flexDirection: "column" }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {isTooltipVisible && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: "50%",
            backgroundColor: colors.neutral.space,
            color: "#fff",
            padding: "8px",
            borderRadius: "4px",
            zIndex: "999",
            marginTop: "8px",
            whiteSpace: "pre-wrap",
            width: "250%",
          }}
        >
          <div>
            <Typography
              variant="caption"
              style={{
                color: "#FFFFFF",
                fontWeight: 400,
                fontSize: 15,
                lineHeight: 1.1,
              }}
            >
              {desc}
            </Typography>
          </div>
        </div>
      )}
    </div>
  )
}
